import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import IosWarningOutline from 'react-ionicons/lib/IosWarningOutline'
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline'
import IosCheckmarkCircleOutline from 'react-ionicons/lib/IosCheckmarkCircleOutline'

import './views.scss'
import '../../index.scss'
const errorText = 'Error'
const successText = 'Success'
const warningText = 'Warning'
const okText = 'Ok'

class Alert extends React.Component {
  getIcon = () => {
    if (this.props.alert.type === 'success') {
      return (
        <IosCheckmarkCircleOutline fontSize="70px" className="alertSuccess" />
      )
    } else if (this.props.alert.type === 'warning') {
      return <IosWarningOutline fontSize="70px" className="alertWarning" />
    } else if (this.props.alert.type === 'error') {
      return <IosCloseCircleOutline fontSize="70px" className="alertError" />
    }
  }

  getMessage = () => {
    if (this.props.alert.type === 'success') {
      return (
        <div className="alertSuccess">
          {this.props.alert.message && this.props.alert.message !== ''
            ? this.props.alert.message
            : successText}
        </div>
      )
    } else if (this.props.alert.type === 'warning') {
      return (
        <div style={{ color: '#fff' }}>
          {this.props.alert.message && this.props.alert.message !== ''
            ? this.props.alert.message
            : warningText}
        </div>
      )
    } else if (this.props.alert.type === 'error') {
      return (
        <div style={{ color: '#fff' }}>
          {this.props.alert.message && this.props.alert.message !== ''
            ? this.props.alert.message
            : errorText}
        </div>
      )
    }
  }

  getButtonText = () => {
    if (this.props.alert.type === 'success') {
      return <div className="alertSuccess">{okText}</div>
    } else if (this.props.alert.type === 'warning') {
      return <div style={{ color: '#C4CE21' }}>{okText}</div>
    } else if (this.props.alert.type === 'error') {
      return <div className="alertError">{okText}</div>
    }
  }

  render() {
    return (
      <div className="alertWindow">
        <div className="alertView">
          <div className="alertIconWrapper">{this.getIcon()}</div>
          <div className="alertMessage">{this.getMessage()}</div>
          <div
            className="buttonWrapper alertButton"
            onClick={this.props.alert.callback}>
            {this.getButtonText()}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ admin }) => ({
  userLoggedIn: admin.userLoggedIn
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Alert)
